module.exports = __webpack_public_path__ + "static/img/5.5201b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/5.png
// module id = zAfX
// module chunks = 0